import { useState } from "react";
import {
  Users,
  Settings,
  List,
  Settings2,
  Building2,
  FileText,
  LogIn,
} from "lucide-react";
import { Tabs, TabPanel } from "@/components/ui/Tabs";
import { UserManagement } from "@/features/admin/UserManagement";
import { AgencySettings } from "@/features/admin/AgencySettings";
import { DropdownManager } from "@/features/admin/DropdownManager";
import { FieldConfig } from "@/features/admin/FieldConfig";
import { DepartmentsList } from "@/features/admin/DepartmentsList";
import { AuditLog } from "@/features/admin/AuditLog";
import { LoginLog } from "@/features/admin/LoginLog";

const ADMIN_TABS = [
  { id: "users", label: "Users", icon: Users },
  { id: "settings", label: "Settings", icon: Settings },
  { id: "dropdowns", label: "Dropdowns", icon: List },
  { id: "fields", label: "Fields", icon: Settings2 },
  { id: "departments", label: "Departments", icon: Building2 },
  { id: "audit", label: "Audit Log", icon: FileText },
  { id: "logins", label: "Login Log", icon: LogIn },
];

export function AdminPage() {
  const [activeTab, setActiveTab] = useState("users");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Administration</h1>
        <p className="text-sm text-muted-foreground">
          Manage users, configure agency settings, and review system activity
        </p>
      </div>

      <Tabs tabs={ADMIN_TABS} activeTab={activeTab} onChange={setActiveTab} />

      <TabPanel id="users" activeTab={activeTab}>
        <UserManagement />
      </TabPanel>

      <TabPanel id="settings" activeTab={activeTab}>
        <AgencySettings />
      </TabPanel>

      <TabPanel id="dropdowns" activeTab={activeTab}>
        <DropdownManager />
      </TabPanel>

      <TabPanel id="fields" activeTab={activeTab}>
        <FieldConfig />
      </TabPanel>

      <TabPanel id="departments" activeTab={activeTab}>
        <DepartmentsList />
      </TabPanel>

      <TabPanel id="audit" activeTab={activeTab}>
        <AuditLog />
      </TabPanel>

      <TabPanel id="logins" activeTab={activeTab}>
        <LoginLog />
      </TabPanel>
    </div>
  );
}
